/**
 * Utility function to ensure proper API URL formatting
 * Handles both URLs with and without trailing slashes
 * 
 * @param {string} baseUrl - The base API URL (with or without trailing slash)
 * @param {string} endpoint - The endpoint to append (e.g., 'graphql')
 * @returns {string} - Properly formatted URL
 */
export function buildApiUrl(baseUrl, endpoint = '') {
  if (!baseUrl) {
    return '';
  }

  // Clean up the base URL to handle documentation typos
  let cleanBaseUrl = baseUrl.trim();
  
  // Remove trailing slash from baseUrl
  cleanBaseUrl = cleanBaseUrl.replace(/\/+$/, '');
  
  // Check if the URL ends with 'graphql' without slash (fix the documentation typo)
  if (cleanBaseUrl.toLowerCase().endsWith('graphql')) {
    // Fix the typo by replacing 'graphql' with '/graphql'
    cleanBaseUrl = cleanBaseUrl.replace(/graphql$/i, '/graphql');
    return cleanBaseUrl;
  }
  
  // Check if the URL already contains '/graphql' (case insensitive)
  if (cleanBaseUrl.toLowerCase().endsWith('/graphql')) {
    return cleanBaseUrl;
  }
  
  // Remove leading slash from endpoint
  const cleanEndpoint = endpoint.replace(/^\/+/, '');
  
  // If no endpoint provided, return the clean base URL
  if (!cleanEndpoint) {
    return cleanBaseUrl;
  }
  
  // Join with single slash
  return `${cleanBaseUrl}/${cleanEndpoint}`;
}

/**
 * Get the GraphQL endpoint URL
 * @returns {string} - The GraphQL endpoint URL
 */
export function getGraphqlUrl() {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000/';
  return buildApiUrl(baseUrl, 'graphql');
}

/**
 * Get the base API URL (without trailing slash)
 * @returns {string} - The base API URL
 */
export function getBaseApiUrl() {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000/';
  return buildApiUrl(baseUrl);
}
